/* eslint-disable max-len */

import getObjectAttributeFromStringKey from '@/common-utils/functions/getObjectAttributeFromStringKey';
import { client } from '../../../../../common-utils/libraries/axios/axios';

import { buildUrl } from '@/common-utils/functions/restUtils';
import generateNestedFieldAccessor from '@/common-utils/functions/generateNestedFieldAccessor';
import searchContractFields from '../../fields/searchContractFields';
import { SEARCH_CONTRACTS } from '../apiUrls';

/**
 * @param responseData response.data object
 * @param responseData.items
 * @param responseData.totalResults
 * @returns Mapped data object
 */
function mapResponseData({ items, totalResults }) {
    const data = {};

    const mappedItems = items.map(item => {
        return {
            [searchContractFields.UUID.key]: item[searchContractFields.UUID.key],

            [searchContractFields.APPLICATION.key]: item[searchContractFields.APPLICATION.key],
            [searchContractFields.BANK_CODE.key]: item[searchContractFields.BANK_CODE.key],
            [searchContractFields.CB_VERSION.key]: item[searchContractFields.CB_VERSION.key],
            [searchContractFields.CB_AGREEMENT_DATE.key]: item[searchContractFields.CB_AGREEMENT_DATE.key],
            [searchContractFields.CB_AGREEMENT_NUMBER.key]: item[searchContractFields.CB_AGREEMENT_NUMBER.key],
            [searchContractFields.CREATED_AT.key]: item[searchContractFields.CREATED_AT.key],
            [searchContractFields.ITP.key]: item[searchContractFields.ITP.key],
            [searchContractFields.LABEL.key]: item[searchContractFields.LABEL.key],
            [searchContractFields.LAST_CONNECTION_DATE.key]: item[searchContractFields.LAST_CONNECTION_DATE.key],
            [searchContractFields.LAST_CONNECTION_TYPE.key]: item[searchContractFields.LAST_CONNECTION_TYPE.key],
            [searchContractFields.LAST_ICCID.key]: item[searchContractFields.LAST_ICCID.key],
            [searchContractFields.LAST_ICCID_OPERATOR.key]: item[searchContractFields.LAST_ICCID_OPERATOR.key],
            [searchContractFields.LAST_REMOTE_COLLECTION_DATE.key]: item[searchContractFields.LAST_REMOTE_COLLECTION_DATE.key],
            [searchContractFields.LAST_SOURCE_IP.key]: item[searchContractFields.LAST_SOURCE_IP.key],
            [searchContractFields.LAST_SSL_VERSION.key]: item[searchContractFields.LAST_SSL_VERSION.key],
            [searchContractFields.LEGAL_BUSINESS_NAME.key]: item[searchContractFields.LEGAL_BUSINESS_NAME.key],
            [searchContractFields.RANK.key]: item[searchContractFields.RANK.key],
            [searchContractFields.REGISTRATION_NUMBER.key]: item[searchContractFields.REGISTRATION_NUMBER.key],
            [searchContractFields.X25_ADDRESS.key]: item[searchContractFields.X25_ADDRESS.key],
            [searchContractFields.MODEL.key]: item[searchContractFields.MODEL.key],
            [searchContractFields.SPECIFICATION.key]: item[searchContractFields.SPECIFICATION.key],
            [searchContractFields.PCI_VERSION.key]: item[searchContractFields.PCI_VERSION.key],
            [searchContractFields.PCI_EXPIRATION_DATE.key]: item[searchContractFields.PCI_EXPIRATION_DATE.key],
            [searchContractFields.PCI_PP_VERSION.key]: item[searchContractFields.PCI_PP_VERSION.key],
            [searchContractFields.PCI_PP_EXPIRATION_DATE.key]: item[searchContractFields.PCI_PP_EXPIRATION_DATE.key],
            [searchContractFields.EXPIRATION_DATE.key]: item[searchContractFields.EXPIRATION_DATE.key],
            [searchContractFields.END_OF_DEPLOYMENT_DATE.key]: item[searchContractFields.END_OF_DEPLOYMENT_DATE.key],
            [searchContractFields.END_OF_USE_DATE.key]: item[searchContractFields.END_OF_USE_DATE.key],
            [searchContractFields.ERT_CODE.key]: item[searchContractFields.ERT_CODE.key],
            [searchContractFields.NUMBER.key]: item[searchContractFields.NUMBER.key],
            [searchContractFields.BULLETINS.key]: item[searchContractFields.BULLETINS.key],
            [searchContractFields.POS_TERMINAL_SUBSCRIPTION.key]: item[searchContractFields.POS_TERMINAL_SUBSCRIPTION.key],

            [searchContractFields.POS_TERMINAL.key]: {
                [searchContractFields.POS_TERMINAL.UUID.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(searchContractFields.POS_TERMINAL.UUID)),
                [searchContractFields.POS_TERMINAL.SERIAL_NUMBER.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(searchContractFields.POS_TERMINAL.SERIAL_NUMBER)),
                [searchContractFields.POS_TERMINAL.MANUFACTURER.key]: getObjectAttributeFromStringKey(item, generateNestedFieldAccessor(searchContractFields.POS_TERMINAL.MANUFACTURER))
            }
        };
    });

    data.items = mappedItems;
    data.totalResults = totalResults;
    return data;
}

const queryGetSearchContracts = (query, enabled) => {
    return {
        queryKey: [SEARCH_CONTRACTS.COLLECTION.queryKey, query],
        queryFn: async () => {
            const response = await client.get(buildUrl(SEARCH_CONTRACTS.COLLECTION.url, query));
            return mapResponseData(response.data);
        },
        enabled: enabled
    };
};


export default queryGetSearchContracts;